// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7026":"f22429390855b6a0","7035":"2682d2742ce0021a"}[chunkId] + ".js";
};